import { faUsers } from '@fortawesome/pro-solid-svg-icons';

import { NavRoute } from '../../shared/navigation/nav.route.interface';

export const getMainNavUsers: () => NavRoute = () => ({
	name: "Users"
	, security: security => security.coreFeatures
	, path: 'users/list'
    , icon: faUsers
    , area: 'users'
    , expanded: globalThis.location.href.includes("/users/")
	, children: [
        {
            name: 'List'
            , exact: true
            , path: 'users/list'
            , activeNavLink: 'users/list'
            , secondaryNav: ['Users', 'List']
        }
        , {
            name: 'Login History'
            , exact: true
            , path: 'users/login-history'
            , activeNavLink: 'users/login-history'
            , secondaryNav: ['Users', 'Login History']
        }
    ]
});
